export default "__VITE_ASSET__22b3772f__"